/**
 * Sticky PDP (desktop): OZ related-product dropdown switches product without full navigation.
 * Syncs sticky + main title, price, hero image, variant id, and data-product-handle; closes combo-boxes.
 */
(function () {
  var DESKTOP_MQ = '(min-width: 1000px)';
  var STICKY_OPTION_SELECT_RE = /^sticky-option\d+$/;
  var SWAPPED_PRICE_ATTR = 'data-yodeyma-oz-swap';

  function isDesktop() {
    return window.matchMedia(DESKTOP_MQ).matches;
  }

  function themeMoneyFormat() {
    var s = window.themeVariables && window.themeVariables.settings;
    if (!s) return;
    return s.currencyCodeEnabled ? s.moneyWithCurrencyFormat : s.moneyFormat;
  }

  function formatMoneyCents(cents) {
    var c = parseInt(cents, 10);
    if (isNaN(c)) c = 0;
    if (typeof window.yodeymaMarketTaxFormatMoney === 'function') {
      return window.yodeymaMarketTaxFormatMoney(c);
    }
    if (window.Shopify && typeof Shopify.formatMoney === 'function') {
      return Shopify.formatMoney(c, themeMoneyFormat());
    }
    return String(c);
  }

  function buildPriceListInnerHtml(priceCents, compareCents) {
    var p = parseInt(priceCents, 10) || 0;
    var cmp = parseInt(compareCents, 10) || 0;
    var onSale = cmp > p;
    var html =
      '<span class="price price--large' + (onSale ? ' price--highlight' : '') + '">' + formatMoneyCents(p) + '</span>';
    if (onSale) {
      html +=
        '<div class="price-list__compare-container"><span class="price price--compare">' +
        formatMoneyCents(cmp) +
        '</span></div>';
    }
    return html;
  }

  /** First swap replaces <product-price-list>; later swaps update the placeholder div. */
  function swapPriceList(container, priceCents, compareCents) {
    if (!container) return;
    var inner = buildPriceListInnerHtml(priceCents, compareCents);
    var nativeList = container.querySelector('product-price-list');
    if (nativeList) {
      var div = document.createElement('div');
      div.className = 'price-list price-list--large price-list--yodeyma-oz-swap';
      div.setAttribute(SWAPPED_PRICE_ATTR, '');
      div.innerHTML = inner;
      nativeList.replaceWith(div);
      return;
    }
    var swapped = container.querySelector('[' + SWAPPED_PRICE_ATTR + ']');
    if (swapped) swapped.innerHTML = inner;
  }

  function updateTitleFirstTextNode(titleEl, text) {
    if (!titleEl) return;
    var ch = titleEl.childNodes;
    for (var i = 0; i < ch.length; i++) {
      if (ch[i].nodeType === Node.TEXT_NODE && String(ch[i].textContent).trim()) {
        ch[i].textContent = text;
        return;
      }
    }
  }

  function setAtcButton(btn, available) {
    if (!btn) return;
    var str = window.themeVariables && window.themeVariables.strings;
    var addLabel = (str && str.productFormAddToCart) || 'Add to cart';
    var soldLabel = (str && str.productFormSoldOut) || 'Sold out';
    btn.disabled = !available;
    btn.textContent = available ? addLabel : soldLabel;
    btn.classList.toggle('button--ternary', !available);
  }

  function closeComboBox(el) {
    if (el) el.open = false;
  }

  function findGalleryHeroImg() {
    return (
      document.querySelector('.product-wrapper .product__media-item.is-selected img') ||
      document.querySelector('.product-wrapper .product__media-item.is-initial-selected img') ||
      document.querySelector('.product-wrapper .product__media-item:not(.is-filtered) img')
    );
  }

  function syncProductContextDom(handle, productId) {
    var idAttr = productId ? ' ' + productId + ' ' : '';
    var wrap = document.querySelector('.product-wrapper[data-product-handle]');
    if (wrap) {
      wrap.setAttribute('data-product-handle', handle);
      if (productId) wrap.setAttribute('data-product-id', idAttr);
    }
    var tagger = document.querySelector('product-tagger[data-product-handle]');
    if (tagger) {
      tagger.setAttribute('data-product-handle', handle);
      if (productId) tagger.setAttribute('data-product-id', idAttr);
    }
    var meta = document.querySelector('product-meta[handle]');
    if (meta) meta.setAttribute('handle', handle);
  }

  function updateOzComboUi(clicked) {
    var listbox = clicked.closest('[role="listbox"]');
    if (listbox) {
      listbox.querySelectorAll('[aria-selected]').forEach(function (el) {
        el.setAttribute('aria-selected', el === clicked ? 'true' : 'false');
      });
    }
    var root = clicked.closest('oz-app-swatches');
    if (!root) return;
    var trigger = root.querySelector('.select .select__selected-value');
    if (!trigger) return;
    var valEl = trigger.querySelector('.select__selected-value-value');
    var labelText = clicked.querySelector('.oz-product-tiles__label-text');
    if (valEl && labelText) valEl.textContent = labelText.textContent;

    var optThumb = clicked.querySelector('.oz-product-tiles__thumb--dropdown');
    var existingThumb = trigger.querySelector('.oz-product-tiles__thumb--dropdown');
    if (!optThumb) return;
    if (existingThumb) {
      existingThumb.innerHTML = optThumb.innerHTML;
      return;
    }
    var wrap = document.createElement('span');
    wrap.className = 'oz-product-tiles__thumb oz-product-tiles__thumb--dropdown oz-product-tiles__thumb--small';
    wrap.innerHTML = optThumb.innerHTML;
    trigger.insertBefore(wrap, trigger.firstChild);
  }

  function applyOzProductSwitch(clicked) {
    var sticky = clicked.closest('product-sticky-form');
    if (!sticky) return;

    var formId = sticky.getAttribute('form-id');
    if (!formId) return;

    var handle = clicked.getAttribute('data-handle');
    var variantId = clicked.getAttribute('data-variant-id');
    var productId = clicked.getAttribute('data-product-id');
    var title = clicked.getAttribute('data-title') || '';
    var priceCents = clicked.getAttribute('data-price-cents') || '0';
    var compareCents = clicked.getAttribute('data-compare-at-cents') || '0';
    var available = clicked.getAttribute('data-available') === 'true';
    var productUrl = clicked.getAttribute('data-product-url') || '';
    var imgSrc = clicked.getAttribute('data-image-src');
    var imgSrcset = clicked.getAttribute('data-image-srcset') || '';
    var imgAlt = clicked.getAttribute('data-image-alt') || title;
    var gallerySrc = clicked.getAttribute('data-gallery-src');

    if (!handle || !variantId) return;

    updateOzComboUi(clicked);

    var stImg = sticky.querySelector('.product-sticky-form__image');
    if (stImg && imgSrc) {
      stImg.setAttribute('src', imgSrc);
      if (imgSrcset) stImg.setAttribute('srcset', imgSrcset);
      else stImg.removeAttribute('srcset');
      if (imgAlt) stImg.setAttribute('alt', imgAlt);
    }

    var stTitle = sticky.querySelector('.product-sticky-form__title');
    if (stTitle) stTitle.textContent = title;

    swapPriceList(sticky.querySelector('.product-sticky-form__price'), priceCents, compareCents);

    var unitRow = sticky.querySelector('.product-sticky-form__unit-price');
    if (unitRow) unitRow.style.display = 'none';

    updateTitleFirstTextNode(document.querySelector('.product-meta .product-meta__title'), title);

    swapPriceList(document.querySelector('.product-meta [data-product-price-list-container]'), priceCents, compareCents);

    if (gallerySrc) {
      var gImg = findGalleryHeroImg();
      if (gImg) {
        gImg.src = gallerySrc;
        gImg.removeAttribute('srcset');
      }
    }

    var form = document.getElementById(formId);
    if (form) {
      form.querySelectorAll('input[name="id"]').forEach(function (inp) {
        inp.value = variantId;
        inp.disabled = false;
      });
    }

    syncProductContextDom(handle, productId);

    setAtcButton(document.getElementById('StickyAddToCart'), available);
    setAtcButton(document.getElementById('AddToCart'), available);

    if (productUrl && window.history && window.history.replaceState) {
      try {
        window.history.replaceState({}, '', productUrl);
      } catch (e) {
        /* ignore */
      }
    }

    document.documentElement.dispatchEvent(
      new CustomEvent('yodeyma:sticky-oz-product', {
        bubbles: true,
        detail: { handle: handle, variantId: variantId, productId: productId },
      })
    );

    closeComboBox(clicked.closest('combo-box'));
  }

  function onStickyVariantOptionClick(ev) {
    if (!isDesktop()) return;
    var opt = ev.target.closest(
      'product-sticky-form combo-box .combo-box__option-item[role="option"]'
    );
    if (!opt || opt.disabled || opt.closest('[data-yodeyma-sticky-oz]')) return;
    var cb = opt.closest('combo-box');
    if (!cb) return;
    window.requestAnimationFrame(function () {
      closeComboBox(cb);
    });
  }

  function onStickyVariantSelectChange(ev) {
    if (!isDesktop()) return;
    var t = ev.target;
    if (!t || t.tagName !== 'SELECT' || !t.closest('product-sticky-form')) return;
    if (!STICKY_OPTION_SELECT_RE.test(t.getAttribute('name') || '')) return;
    closeComboBox(t.closest('combo-box'));
  }

  function onStickyOzTileClickCapture(ev) {
    if (!isDesktop()) return;
    var t = ev.target.closest('[data-yodeyma-sticky-oz].combo-box__option-item');
    if (!t || t.disabled || !t.closest('product-sticky-form')) return;
    ev.preventDefault();
    applyOzProductSwitch(t);
  }

  document.addEventListener('click', onStickyVariantOptionClick, false);
  document.addEventListener('change', onStickyVariantSelectChange, true);
  document.addEventListener('click', onStickyOzTileClickCapture, true);
})();
